export default "__VITE_ASSET__BNeECRpj__"